import { render, staticRenderFns } from "./CadastrarCategoriaFinanceira.vue?vue&type=template&id=e83b6a70&scoped=true"
import script from "./CadastrarCategoriaFinanceira.vue?vue&type=script&lang=js"
export * from "./CadastrarCategoriaFinanceira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83b6a70",
  null
  
)

export default component.exports